export enum SchedulingView {
  Cancel = 'CANCEL',
  Reschedule = 'RESCHEDULE',
}
